module.exports = __webpack_public_path__ + "static/media/banner_bg.c66382cc.png";